import type { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { evaluateAccess, subscriptionApi } from '../api/subscription';
import { TrialBanner } from './TrialBanner';
import { ExpiredScreen } from '../routes/SubscribePage';

// Same access rules as the app's CareTeamTabNavigator, including "fail open" on
// a network error so a flaky connection never locks a provider out.
export function SubscriptionGate({ children }: { children: ReactNode }) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['subscription-status'],
    queryFn: subscriptionApi.getStatus,
    staleTime: 5 * 60_000,
  });

  if (isLoading) {
    return (
      <div className="center-screen">
        <div className="spinner" />
      </div>
    );
  }

  const access = isError || !data ? { state: 'active' as const } : evaluateAccess(data);

  if (access.state === 'expired') {
    return <ExpiredScreen />;
  }

  return (
    <>
      {access.state === 'trial' && <TrialBanner daysLeft={access.daysLeft} />}
      {children}
    </>
  );
}
